export default __webpack_public_path__ + "static/media/ctoken-eth.aa8d8081.svg";